// extracted by mini-css-extract-plugin
export default {"main":"main_main__72cOi"};